import Vue from "vue";
import Vuex from "vuex";
import apiClient from "../services/ApiServices";
import router from '@/router/index';
import jwt_decode from "jwt-decode";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        access_token: localStorage.getItem('token'),
        refresh: localStorage.getItem('refresh'),
        remember_me: localStorage.getItem('remember'),
        expirationStatus: false,
        user: {
            username: '',
        }
    },
    mutations: {
        updateStorage(state, { access_token, refresh }) {
            localStorage.setItem('token', access_token)
            localStorage.setItem('refresh', refresh)

            state.access_token = access_token
            state.refresh = refresh
            let token = jwt_decode(state.access_token)
            let user_id = token.user_id
            Vue.prototype.$user_id = user_id
        },
        removeStorage(state) {
            localStorage.removeItem('token');
            localStorage.removeItem('refresh');
            localStorage.removeItem('remember');
            state.access_token = null
            state.refresh = null
        },
        setUserDetail(state, data) {
            state.user = data
        },
        changeExpirationStatus(state, status) {
            state.expirationStatus = status
        }
    },
    actions: {
        async login(context, credentials) {
            const data = new FormData()
            data.append('username', credentials.username)
            data.append('password', credentials.password)
            await axios.post(`${process.env.VUE_APP_CORPORATE_BASE_URL}auth/login/`, data)
                .then((response) => {
                    localStorage.setItem('remember', credentials.remember_me)
                    context.commit('updateStorage', { access_token: response.data.data.access_token, refresh: response.data.data.refresh })
                }).catch((error) => {
                    return Promise.reject(error);
                })

        },
        async logout(context) {
            const data = new FormData()
            data.append('refresh', localStorage.getItem('refresh'))

            await axios.post(`${process.env.VUE_APP_CORPORATE_BASE_URL}auth/logout/`, data)
                .then(() => {
                    context.commit('removeStorage')
                    router.push({ name: 'Login' })
                })
        },
        async refreshToken(context) {
            const data = new FormData()
            data.append('refresh', this.state.refresh)
            await axios.post(`${process.env.VUE_APP_CORPORATE_BASE_URL}auth/refresh/`, data)
                .then((response) => {
                    context.commit('updateStorage', { access_token: response.data.data.access_token, refresh: response.data.data.refresh })
                })
        },
        async userDetail(context, user_id) {
            await apiClient.get(`${user_id}/`, {
                    headers: {
                        Authorization: 'Bearer ' + this.state.access_token
                    }
                })
                .then((response) => {
                    context.commit('setUserDetail', response.data.data)
                })
        },
        tokenInvalid(context) {
            context.commit('removeStorage')
            router.push({ name: 'Login' })
        }
    },
    getters: {
        loggedIn(state) {
            return state.access_token != null
        },
        user(state) {
            return state.user
        },
        userFieldStatus(state) {
            return state.user.name == "" || state.user.pic == "" || state.user.phone == "" || state.user.country == ""
        },
        user_id() {
            const access_token = jwt_decode(localStorage.getItem('token'))
            return access_token.user_id
        }
    },
    modules: {},
});